import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { getSeniorHomesRequest, getUserEditFormData, getUsersRequest, setUserEditFormDataRequest, updateUserEditRequest } from "../redux/actions";
import { editSeniorByHNRequest, getNursesByHNRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { getDefaultOptions, getOptions } from "../utils/autocomplete";
import { ROLE } from "../utils/constants";
import Autocomplete from "./Autocomplete";
import SwitchButton from "./SwitchButton";
import { localePath } from "../i18n/config";
// import axios from "axios";
// import { toast } from 'react-toastify';

const UserEditForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const user = useSelector((state: AppState) => state.user);
    // const resources = useSelector((state: AppState) => state.seniorHomes);
    const nurseStaff: any = useSelector((state: AppState) => state.nurses.list);
    const nursesForHN: any = useSelector((state: AppState) => state.headNurse.nurses.list);
    const users: any = useSelector((state: AppState) => state.users);
    const { profile } = users;

    const segmentNurses = user.role === ROLE.HEAD_NURSE ? nursesForHN : nurseStaff;

    const [formData, setFormData] = useState({
        id: "",
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        mobileNumber: "",
        device_imei4: "",
        role: "",
        isAdmin: false,
        readOnly: true,
        isSenior: false,
        customerId: "",
        department: "",
        nursingHome: "",
        homeAddress: "",
        homeCity: "",
        homePostalCode: "",
        nursingHomeAddress: profile?.nursingHomeAddress,
        password: "",
        hasItSupport: false,
        hasNurseSupport: false,
        nurses: [],
        customers: [],
        chosenService: profile?.chosenService,
        tabletLanguage: profile?.tabletLanguage,
        autoAnswer: profile?.autoAnswer,
        serviceOption: profile?.serviceOption,
        hasNurseCalling: false,
    });
    const [assignedNurses, setAssignedNurses] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (user && (user.isAdmin || user.role === "it_support" || user.role === "head_nurse")) {
            dispatch(getUserEditFormData(id));
            dispatch(getUsersRequest());
            dispatch(getSeniorHomesRequest());
            dispatch(getNursesByHNRequest());
        } else {
            history.push(localePath("kirjaudu"));
        }
        return () => {};
    }, [dispatch, history, user, id]);

    useEffect(() => {
        if (profile && Object.keys(profile).length > 0 && users?.list?.users && segmentNurses) {
            const needsNurses = profile.isSenior && segmentNurses && segmentNurses.length > 0;
            const _nurses = profile.isSenior && needsNurses ? getDefaultOptions(segmentNurses, profile.nurses) : [];
            const _customers = profile.customers ? getDefaultOptions(users?.list?.users || [], profile.customers) : []; // Handle customers array
            const _hasItSupport = profile.hasOwnProperty("hasItSupport") ? (profile.hasItSupport === 1 ? true : false) : false;
            const _hasNurseSupport = profile.hasOwnProperty("hasNurseSupport") ? (profile.hasNurseSupport === 1 ? true : false) : false;
            const _hasNurseCalling = profile.hasOwnProperty("hasNurseCalling") ? (profile.hasNurseCalling === 1 ? true : false) : false;

            setFormData((prevValue: any) => {
                return {
                    ...prevValue,
                    ...profile,
                    nurses: _nurses,
                    customers: _customers, // Set customers
                    hasItSupport: _hasItSupport,
                    hasNurseSupport: _hasNurseSupport,
                    hasNurseCalling: _hasNurseCalling,
                };
            });
            setAssignedNurses(_nurses);
            setSelectedCustomers(_customers); // Set selected customers
        }
    }, [users, profile, segmentNurses]);

    const [showPass, setShowPass] = useState(false);
    const showPassHandler = () => {
        setShowPass((current) => !current);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name } = e.target;
        setFormData((prevValue: any) => {
            return {
                ...prevValue,
                [name]: value,
            };
        });
    };

    const handleChangeBoolean = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData((prevValue: any) => {
            return {
                ...prevValue,
                [e.target.name]: e.target.value === "true",
            };
        });
    };

    const handleAssignedNurses = (_nurses: any) => {
        setFormData((prevValue: any) => {
            return {
                ...prevValue,
                nurses: _nurses,
                hasNurseSupport: _nurses.length === 0 ? false : prevValue.hasNurseSupport,
            };
        });
        setAssignedNurses(_nurses);
        if (_nurses.length > 0) {
            setError(false);
        }
    };

    const handleAssignedCustomers = (_customers: any[]) => {
        const newCustomer = _customers.length > 0 ? [_customers[0]] : [];

        setFormData((prevValue: any) => {
            return {
                ...prevValue,
                customers: newCustomer,
            };
        });
        setSelectedCustomers(newCustomer as any);
    };

    const getCustomerOptions = (allUsers: any[], selectedCustomers: any[]) => {
        const customers = allUsers.filter((user) => user.role === ROLE.CUSTOMER || user.role === "customer");
        // Pass selectedCustomers array directly since getOptions expects an array
        return getOptions(customers, selectedCustomers || []);
    };
    const handleItSupport = () => {
        setFormData((prevValue: any) => {
            return {
                ...prevValue,
                hasItSupport: !formData.hasItSupport,
            };
        });
    };

    const handleToggleButton = (field: string) => {
        if (field === "nurseSupport") {
            setFormData((prevValue: any) => {
                return {
                    ...prevValue,
                    hasNurseSupport: !formData.hasNurseSupport,
                    nurses: !formData.hasNurseSupport === true ? assignedNurses : [],
                    hasNurseCalling: !formData.hasNurseSupport ? prevValue.hasNurseCalling : false,
                };
            });
        } else if (field === "nurseCalling") {
            setFormData((prevValue: any) => {
                return {
                    ...prevValue,
                    hasNurseCalling: !formData.hasNurseCalling,
                };
            });
        }
    };

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        const { hasItSupport, hasNurseSupport, nurses, ...userEditFormData } = formData;
        let _formData: any = {
            id: formData.id,
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            username: formData.username,
            mobileNumber: formData.mobileNumber,
        };
        if (formData.role === "senior" || formData.isSenior === true) {
            _formData = {
                ..._formData,
                nurses: formData.nurses.map((nurse: any) => nurse.value),
                hasItSupport: formData.hasItSupport ? 1 : 0,
                hasNurseSupport: formData.hasNurseSupport ? 1 : 0,
                hasNurseCalling: formData.hasNurseCalling ? 1 : 0,
            };
        }

        // Handle customers array - extract customer IDs
        if (formData.customers && formData.customers.length > 0) {
            const customerIds = formData.customers.map((customer: any) => customer.value || customer.id);
            if (customerIds.length === 1) {
                _formData.customerId = customerIds[0];
            }
        }
        if (_formData.hasNurseSupport === 1 && _formData.nurses.length === 0) {
            setError(true);
        } else {
            if (user.role === ROLE.HEAD_NURSE && formData.role === ROLE.SENIOR) {
                dispatch(editSeniorByHNRequest(_formData));
                dispatch(updateUserEditRequest(userEditFormData));
            } else {
                dispatch(
                    setUserEditFormDataRequest({
                        _formData: _formData,
                        userEditFormData: userEditFormData,
                    })
                );
            }
            history.push("/admin/users");
        }
    };

    if (profile) {
        return (
            <Container className="register-form-container">
                <Form onSubmit={submitHandler} className="service-form">
                    <Form.Group controlId="user-id">
                        <Form.Label>ID</Form.Label>
                        <Form.Control type="number" placeholder="ID" value={formData.id} readOnly={true} />
                    </Form.Group>
                    <Form.Group controlId="user-id">
                        <Form.Label>R-ID</Form.Label>
                        <Form.Control type="number" placeholder="R-ID" value={profile?.groupId} readOnly={true} />
                    </Form.Group>
                    <Form.Group controlId="user-preferred-locale">
                        <Form.Label>Preferred Locale</Form.Label>
                        <Form.Control type="text" placeholder="-" value={profile?.preferred_locale || "-"} readOnly={true} />
                    </Form.Group>
                    <hr />
                    <Form.Group controlId="service-role">
                        <Form.Label>Rooli</Form.Label>
                        <Form.Control as="select" name="role" value={formData.role} onChange={handleChange} disabled={user.readOnly || !user.isAdmin}>
                            <option value="customer">Asiakas (customer)</option>
                            <option value="senior">Senior (senior)</option>
                            <option value="member">Jäsen (member)</option>
                        </Form.Control>
                    </Form.Group>

                    {/* Customer Assignment Section - Updated for multiple selection */}
                    {user.role === ROLE.HEAD_NURSE && formData.role === ROLE.SENIOR && (
                        <Form.Group controlId="service-assignCustomer">
                            <Form.Label>Add/Edit Customer</Form.Label>
                            <Autocomplete
                                options={getCustomerOptions(users?.list?.users || [], formData.customers)}
                                handleOptions={handleAssignedCustomers}
                                value={selectedCustomers || []}
                                placeholder={"Enter Customer Name/ID"}
                                isDisabled={!(user.isAdmin || user.role === ROLE.HEAD_NURSE) && user.role !== ROLE.HEAD_NURSE}
                                isMulti={true} // Changed to true for multiple selection
                            />
                        </Form.Group>
                    )}

                    {user.role !== ROLE.HEAD_NURSE && (
                        <Form.Group controlId="service-isAdmin">
                            <Form.Label>Admin?</Form.Label>
                            <Form.Control
                                as="select"
                                name="isAdmin"
                                value={typeof formData.isAdmin === "boolean" ? formData.isAdmin.toString() : "false"}
                                disabled={user.readOnly || user.id === profile.id || !user.isAdmin}
                                onChange={handleChangeBoolean}
                            >
                                <option value="true">Joo</option>
                                <option value="false">Ei</option>
                            </Form.Control>
                        </Form.Group>
                    )}
                    {formData.isAdmin && (
                        <Form.Group controlId="service-readOnly">
                            <Form.Label>readOnly?</Form.Label>
                            <Form.Control as="select" name="readOnly" value={typeof formData.readOnly === "boolean" ? formData.readOnly.toString() : "false"} disabled={user.readOnly || user.id === profile.id} onChange={handleChangeBoolean}>
                                <option value="true">Joo</option>
                                <option value="false">Ei</option>
                            </Form.Control>
                        </Form.Group>
                    )}
                    <hr />
                    <Form.Group controlId="service-username">
                        <Form.Label>Käyttäjänimi</Form.Label>
                        <Form.Control type="text" placeholder="Käyttäjänimi" name="username" value={formData.username} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>
                    <Form.Group controlId="service-email">
                        <Form.Label>Sähköposti</Form.Label>
                        <Form.Control type="text" placeholder="Sähköposti" name="email" value={formData.email} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>
                    <Form.Group controlId="service-firstName">
                        <Form.Label>Etunimi</Form.Label>
                        <Form.Control type="text" placeholder="Etunimi" name="firstName" value={formData.firstName} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>
                    <Form.Group controlId="service-lastName">
                        <Form.Label>Sukunimi</Form.Label>
                        <Form.Control type="text" placeholder="Sukunimi" name="lastName" value={formData.lastName} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>
                    <Form.Group controlId="service-mobileNumber">
                        <Form.Label>Matkapuhelinnumero</Form.Label>
                        <Form.Control type="text" placeholder="Matkapuhelinnumero" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>
                    <Form.Group controlId="service-device_imei4">
                        <Form.Label>Tabletti</Form.Label>
                        <Form.Control type="text" placeholder="Tabletti" name="device_imei4" value={formData.device_imei4} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>

                    <Form.Group controlId="service-isSenior">
                        <Form.Label>Itse seniori</Form.Label>
                        <Form.Control
                            as="select"
                            name="isSenior"
                            value={typeof formData.isSenior === "boolean" ? formData.isSenior.toString() : "false"}
                            onChange={handleChangeBoolean}
                            disabled={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)}
                        >
                            <option value="true">Joo</option>
                            <option value="false">Ei</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="service-customerId">
                        <Form.Label>Customer ID (Stripe)</Form.Label>
                        <Form.Control type="text" placeholder="Customer ID (Stripe)" name="customerId" value={formData.customerId} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                    </Form.Group>

                    <Form.Group controlId="service-department">
                        <Form.Label>Osoitetiedot</Form.Label>
                        <Form.Control as="select" name="department" value={formData.department} onChange={handleChange} disabled={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)}>
                            <option value={undefined}>Ei valittu</option>
                            <option value="homeAddress">Kotona</option>
                            <option value="nursingHome">Asumispalvelussa</option>
                        </Form.Control>
                    </Form.Group>

                    {formData.department === "homeAddress" && (
                        <div>
                            <Form.Group>
                                <Form.Label>Katuosoite</Form.Label>
                                <Form.Control type="text" name="homeAddress" placeholder="Katuosoite" value={formData.homeAddress} onChange={handleChange} readOnly={user.readOnly || !(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                            </Form.Group>
                            <Form.Group controlId="city">
                                <Form.Label>Postinumero</Form.Label>
                                <Form.Control type="text" name="homePostalCode" placeholder="Postinumero" value={formData.homePostalCode} onChange={handleChange} readOnly={!(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                            </Form.Group>
                            <Form.Group controlId="city">
                                <Form.Label>Kaupunki</Form.Label>
                                <Form.Control type="text" name="homeCity" placeholder="Kaupunki" value={formData.homeCity} onChange={handleChange} readOnly={!(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                            </Form.Group>
                        </div>
                    )}
                    {formData.department === "nursingHome" && (
                        <div>
                            <Form.Group>
                                <Form.Label>Vanhainkodin nimi</Form.Label>
                                <Form.Control type="text" name="nursingHome" placeholder="Vanhainkodin nimi" value={formData.nursingHome} onChange={handleChange} readOnly={!(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                            </Form.Group>
                            <Form.Group controlId="city">
                                <Form.Label>Paikkakunta</Form.Label>
                                <Form.Control type="text" name="nursingHomeAddress" placeholder="Paikkakunta" value={formData.nursingHomeAddress} onChange={handleChange} readOnly={!(user.isAdmin || user.role === ROLE.HEAD_NURSE)} />
                            </Form.Group>
                        </div>
                    )}

                    {!user.readOnly && (formData.role === "senior" || formData.isSenior) && (
                        <Form.Group controlId="service-password">
                            <Form.Label>Salasana (Jätä tyhjäksi välttääksesi käyttäjän salasanan nollaamisen)</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showPass ? "text" : "password"}
                                    placeholder="Salasana"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    disabled={user.isAdmin || user.role === ROLE.HEAD_NURSE ? false : true}
                                />
                                <Button variant="outline-secondary shadow-none show-password-btn" onClick={showPassHandler} disabled={user.isAdmin || user.role === ROLE.HEAD_NURSE ? false : true}>
                                    <i className={showPass ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                                </Button>
                            </InputGroup>
                            <div className="show-password">Näet salasanasi klikkaamalla silmäkuvaketta</div>
                            <small className="password-length">Vähintään 11 merkkiä.</small>
                        </Form.Group>
                    )}

                    {(formData.role === "senior" || formData.isSenior) && (
                        <>
                            <Form.Group controlId="service-nurseSupport">
                                <Form.Label style={{ marginRight: "5rem" }}>Nurse Support</Form.Label>
                                <SwitchButton isChecked={formData.hasNurseSupport} handleChecked={() => handleToggleButton("nurseSupport")} disabled={user.isAdmin || user.role === ROLE.HEAD_NURSE ? false : true} />
                            </Form.Group>
                            <Form.Group controlId="service-nurseCalling">
                                <Form.Label style={{ marginRight: "5rem" }}>Nurse Calling</Form.Label>
                                <SwitchButton
                                    isChecked={formData.hasNurseCalling}
                                    handleChecked={() => handleToggleButton("nurseCalling")}
                                    disabled={(user.isAdmin || user.role === ROLE.HEAD_NURSE) && formData.hasNurseSupport ? false : true}
                                />
                            </Form.Group>
                            <Form.Group controlId="service-addEditNurse">
                                <Form.Label>Add/Edit nurse</Form.Label>
                                <Autocomplete
                                    options={getOptions(segmentNurses, formData.nurses)}
                                    handleOptions={handleAssignedNurses}
                                    value={assignedNurses}
                                    placeholder={"Enter Nurse Name/ID"}
                                    isDisabled={!(formData.hasNurseSupport && (user.isAdmin || user.role === ROLE.HEAD_NURSE))}
                                />
                                {error && <p style={{ color: "red" }}>Please select any nurse</p>}
                            </Form.Group>

                            <Form.Group controlId="service-itSupport">
                                <Form.Label style={{ marginRight: "7rem" }}>IT Support</Form.Label>
                                <SwitchButton isChecked={formData.hasItSupport} handleChecked={handleItSupport} disabled={user.isAdmin || user.role === ROLE.HEAD_NURSE ? false : true} />
                            </Form.Group>
                        </>
                    )}

                    {formData.role === "customer" && (
                        <Form.Group controlId="service-language">
                            <Form.Label>Kieli</Form.Label>
                            <Form.Control as="select" name="tabletLanguage" value={formData.tabletLanguage} disabled={user.isAdmin ? false : true}>
                                <option value="">-</option>
                                <option value="suomi">Suomi</option>
                                <option value="ruotsi">Ruotsi</option>
                            </Form.Control>
                        </Form.Group>
                    )}

                    {formData.role === "customer" && (
                        <Form.Group controlId="service-autoanswer">
                            <Form.Label>Autoanswer</Form.Label>
                            <Form.Control as="select" name="autoAnswer" value={formData.autoAnswer} disabled={user.isAdmin ? false : true}>
                                <option value="">-</option>
                                <option value="true">{`Videopuhelu avautuu automaattisesti ilman kosketusta${formData.chosenService === "mestari" ? " (mahdollinen Samsung tabletissa)" : ""}`}</option>
                                <option value="false">{`Videopuhelu ei avaudu automaattisesti ilman kosketusta${formData.chosenService === "mestari" ? " (Samsung tai Apple)" : ""}`}</option>
                            </Form.Control>
                        </Form.Group>
                    )}

                    {formData.role === "customer" && ["helppo", "huoleton", "suosikkipalvelu"].includes(formData?.chosenService) && (
                        <Form.Group controlId="service-option">
                            <Form.Label>Sovellukset</Form.Label>
                            <Form.Control as="select" name="serviceOption" value={formData.serviceOption} disabled={user.isAdmin ? false : true}>
                                <option value="">-</option>
                                <option value="huoleton1">Videopuhelu</option>
                                <option value="huoleton2">Videopuhelut, äänikirjat, radio</option>
                                <option value="huoleton3">Videopuhelut, äänikirjat, radio, lääkemuistutus, YleAreena, Chrome</option>
                                <option value="helppo1">Videopuhelut</option>
                                <option value="helppo2">Videopuhelut, äänikirjat, radio</option>
                                <option value="helppo3">Videopuhelut, äänikirjat, radio, lääkemuistutus, YleAreena, Chrome</option>
                                <option value="helppo4">Videopuhelut, äänikirjat, radio, lääkemuistutus, uutiset, YleAreena, pelit, Chrome</option>
                                <option value="helppo5">Videopuhelut, äänikirjat, radio, lääkemuistutus, uutiset, YleAreena, pelit, Chrome, taide, Spotify, WhatsApp</option>
                            </Form.Control>
                        </Form.Group>
                    )}
                    {formData.role === "customer" && ["phone"].includes(formData?.chosenService) && (
                        <Form.Group controlId="service-option">
                            <Form.Label>Sovellukset</Form.Label>
                            <Form.Control as="select" name="serviceOption" value={formData.serviceOption} disabled={user.isAdmin ? false : true}>
                                <option value="">-</option>
                                <option value="puhelimen1">Videopuhelu</option>
                                <option value="puhelimen2">Videopuhelu, puhelut, yhteystiedot, tekstiviestit, kamera, galleria</option>
                                <option value="puhelimen3">Videopuhelu, puhelut, yhteystiedot, tekstiviestit, kamera, galleria, Google Chrome, Iltasanomat, Play -kauppa (voi lisätä omia sovelluksia)</option>
                            </Form.Control>
                        </Form.Group>
                    )}
                    <Row>
                        <Col>
                            <LinkContainer to={`/admin/users`}>
                                <Button className="tallenna paymentmethod-back-button">Takaisin</Button>
                            </LinkContainer>
                        </Col>
                        {!user.readOnly && (user.isAdmin || user.role === ROLE.HEAD_NURSE) && (
                            <Col
                                style={{
                                    textAlign: "right",
                                }}
                            >
                                <Button className="create-service-button tallenna" type="submit">
                                    Tallenna
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Form>
            </Container>
        );
    } else {
        return (
            <Container>
                <div>Käyttäjää ei löydy</div>
                <LinkContainer to={`/admin/users`}>
                    <Button>Takaisin</Button>
                </LinkContainer>
            </Container>
        );
    }
};

export default UserEditForm;
